"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.readNumber = exports.readFractionalPart = exports.readIntegralPart = exports.parseNumberData = exports.zipIntegralPeriods = exports.addLeadingZerosToFitPeriod = exports.trimRedundantZeros = exports.removeThousandsSeparators = exports.readThreeDigits = exports.readLastTwoDigits = void 0;
const type_1 = require("./type");
const util_1 = require("./util");
function readLastTwoDigits(config, b, c) {
    const output = [];
    switch (b) {
        case 0: {
            output.push(config.digits[c]);
            break;
        }
        case 1: {
            output.push(config.tenText);
            if (c === 5) {
                output.push(config.fiveToneText);
            }
            else if (c !== 0) {
                output.push(config.digits[c]);
            }
            break;
        }
        default: {
            output.push(config.digits[b], config.tenToneText);
            if (c === 1) {
                output.push(config.oneToneText);
            }
            else if (c === 4) {
                output.push(config.fourToneText);
            }
            else if (c === 5) {
                output.push(config.fiveToneText);
            }
            else if (c !== 0) {
                output.push(config.digits[c]);
            }
            break;
        }
    }
    return output;
}
exports.readLastTwoDigits = readLastTwoDigits;
function readThreeDigits(config, a, b, c, readZeroHundred) {
    const output = [];
    const hasHundred = a !== 0 || readZeroHundred;
    if (hasHundred) {
        output.push(config.digits[a], config.hundredText);
    }
    if (hasHundred && b === 0) {
        if (c === 0) {
            return output;
        }
        output.push(config.oddText);
    }
    output.push(...readLastTwoDigits(config, b, c));
    return output;
}
exports.readThreeDigits = readThreeDigits;
function removeThousandsSeparators(config, number) {
    const regex = new RegExp(config.thousandSign, 'g');
    return number.replace(regex, '');
}
exports.removeThousandsSeparators = removeThousandsSeparators;
function trimRedundantZeros(config, number) {
    return number.includes(config.pointSign)
        ? (0, util_1.trimLeft)((0, util_1.trimRight)(number, config.filledDigit), config.filledDigit)
        : (0, util_1.trimLeft)(number, config.filledDigit);
}
exports.trimRedundantZeros = trimRedundantZeros;
function addLeadingZerosToFitPeriod(config, number) {
    const newLength = Math.ceil(number.length / config.periodSize) * config.periodSize;
    return number.padStart(newLength, config.filledDigit);
}
exports.addLeadingZerosToFitPeriod = addLeadingZerosToFitPeriod;
function zipIntegralPeriods(config, digits) {
    const output = [];
    const periodCount = Math.ceil(digits.length / config.periodSize);
    for (let i = 0; i < periodCount; i++) {
        const [a, b, c] = digits.slice(i * config.periodSize, (i + 1) * config.periodSize);
        output.push([a, b, c]);
    }
    return output;
}
exports.zipIntegralPeriods = zipIntegralPeriods;
function parseNumberData(config, number) {
    let numberString = removeThousandsSeparators(config, number);
    const isNegative = numberString[0] === config.negativeSign;
    numberString = isNegative ? numberString.substring(1) : numberString;
    numberString = trimRedundantZeros(config, numberString);
    const pointPos = numberString.indexOf(config.pointSign);
    let integralString = pointPos === -1 ? numberString : numberString.substring(0, pointPos);
    const fractionalString = pointPos === -1 ? '' : numberString.substring(pointPos + 1);
    integralString = addLeadingZerosToFitPeriod(config, integralString);
    const integralDigits = (0, util_1.splitToDigits)(integralString);
    const fractionalDigits = (0, util_1.splitToDigits)(fractionalString);
    if (integralDigits.includes(NaN) || fractionalDigits.includes(NaN)) {
        throw new type_1.InvalidNumberError();
    }
    const integralPart = zipIntegralPeriods(config, integralDigits);
    if (integralPart.length === 0) {
        integralPart.push([0, 0, 0]);
    }
    else if (integralPart.length > config.units.length) {
        throw new type_1.UnitNotEnoughError();
    }
    const fractionalPart = fractionalDigits;
    return { isNegative, integralPart, fractionalPart };
}
exports.parseNumberData = parseNumberData;
function readIntegralPart(config, periods) {
    const output = [];
    const isSinglePeriod = periods.length === 1;
    for (const [index, period] of periods.entries()) {
        const isFirstPeriod = index === 0;
        const [a, b, c] = period;
        if (a !== 0 || b !== 0 || c !== 0 || isSinglePeriod) {
            output.push(...readThreeDigits(config, a, b, c, !isFirstPeriod), ...config.units[periods.length - 1 - index]);
        }
    }
    return output;
}
exports.readIntegralPart = readIntegralPart;
function readFractionalPart(config, digits) {
    const output = [];
    switch (digits.length) {
        case 2: {
            const [b, c] = digits;
            output.push(...readLastTwoDigits(config, b, c));
            break;
        }
        case 3: {
            const [a, b, c] = digits;
            output.push(...readThreeDigits(config, a, b, c, true));
            break;
        }
        default: {
            for (const digit of digits) {
                output.push(config.digits[digit]);
            }
            break;
        }
    }
    return output;
}
exports.readFractionalPart = readFractionalPart;
function readNumber(config, numberData) {
    const output = [];
    output.push(...readIntegralPart(config, numberData.integralPart));
    if (numberData.fractionalPart.length !== 0) {
        output.push(config.pointText, ...readFractionalPart(config, numberData.fractionalPart));
    }
    if (numberData.isNegative) {
        output.unshift(config.negativeText);
    }
    output.push(...config.unit);
    return output.join(config.separator);
}
exports.readNumber = readNumber;
